// helpers.js
import axios from "axios";
import { jwtDecode } from "jwt-decode";

const API_URL = process.env.REACT_APP_API_URL;

export const getToken = async () => {
  try {
    const token = localStorage.getItem("accessToken");

    if (token) {
      return token;
    }
    return null;
  } catch (error) {
    console.error("Error getting token", error);
  }
};

export const saveTokens = async (accessToken, refreshToken) => {
  try {
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
  } catch (error) {
    console.error("Error saving tokens", error);
  }
};

export const checkAndRefreshToken = async () => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken) {
      console.log("Отсутствует refreshToken");
      return;
    }

    if (!accessToken || isTokenExpired(accessToken)) {
      const newAccessToken = await refreshAccessToken(refreshToken);
      if (newAccessToken) {
        localStorage.setItem("accessToken", newAccessToken);
        console.log("Токен успешно обновлен");
      } else {
        console.log(
          "Ошибка обновления токена, пользователь должен заново войти"
        );
      }
    }
  } catch (error) {
    console.log("Ошибка при проверке/обновлении токена:", error);
  }
};

const refreshAccessToken = async (refreshToken) => {
  try {
    const response = await axios.post(`${API_URL}/owners/refresh-token`, {
      refreshToken,
    });

    return response.data.accessToken || null;
  } catch (error) {
    console.log("Ошибка при обновлении accessToken:", error);
    return null;
  }
};

const isTokenExpired = (token) => {
  try {
    if (!token) return true;
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch (error) {
    console.log("Ошибка декодирования токена:", error);
    return true;
  }
};
// Clear tokens
export const clearTokens = async () => {
  try {
  } catch (error) {
    console.error("Error clearing tokens", error);
  }
};
